module.exports = __webpack_public_path__ + "static/media/home-contracting-1@2x.964b7252.jpg";